var l;!function(l){l.full="full",l.partial="partial",l.none="none"}(l||(l={}));export{l as AddressModeOptions};
